export default function CustomerSupport() {
  return (
    <svg width="48" height="49" viewBox="0 0 48 49" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10.2858 24.4988V15.4817C10.3126 13.7092 10.6888 11.9595 11.393 10.3327C12.0972 8.70585 13.1154 7.23399 14.3894 6.0014C15.6634 4.76881 17.1681 3.79972 18.8173 3.14965C20.4665 2.49959 22.2277 2.18133 24.0001 2.2131C25.7725 2.18133 27.5337 2.49959 29.1829 3.14965C30.832 3.79972 32.3367 4.76881 33.6107 6.0014C34.8847 7.23399 35.903 8.70585 36.6071 10.3327C37.3113 11.9595 37.6876 13.7092 37.7144 15.4817V24.4988M30.8572 42.4988C32.6758 42.4988 34.42 41.7764 35.7059 40.4904C36.9919 39.2044 37.7144 37.4603 37.7144 35.6417V27.9274M30.8572 42.4988C30.8572 43.6355 30.4057 44.7255 29.602 45.5293C28.7982 46.333 27.7081 46.7845 26.5715 46.7845H21.4286C20.292 46.7845 19.2019 46.333 18.3982 45.5293C17.5945 44.7255 17.1429 43.6355 17.1429 42.4988C17.1429 41.3622 17.5945 40.2721 18.3982 39.4684C19.2019 38.6646 20.292 38.2131 21.4286 38.2131H26.5715C27.7081 38.2131 28.7982 38.6646 29.602 39.4684C30.4057 40.2721 30.8572 41.3622 30.8572 42.4988ZM5.14293 19.356H8.5715C9.02616 19.356 9.46219 19.5366 9.78368 19.8581C10.1052 20.1796 10.2858 20.6156 10.2858 21.0702V31.356C10.2858 31.8106 10.1052 32.2467 9.78368 32.5681C9.46219 32.8896 9.02616 33.0702 8.5715 33.0702H5.14293C4.23361 33.0702 3.36154 32.709 2.71856 32.066C2.07558 31.4231 1.71436 30.551 1.71436 29.6417V22.7845C1.71436 21.8752 2.07558 21.0031 2.71856 20.3602C3.36154 19.7172 4.23361 19.356 5.14293 19.356ZM42.8572 33.0702H39.4286C38.974 33.0702 38.5379 32.8896 38.2165 32.5681C37.895 32.2467 37.7144 31.8106 37.7144 31.356V21.0702C37.7144 20.6156 37.895 20.1796 38.2165 19.8581C38.5379 19.5366 38.974 19.356 39.4286 19.356H42.8572C43.7665 19.356 44.6386 19.7172 45.2816 20.3602C45.9246 21.0031 46.2858 21.8752 46.2858 22.7845V29.6417C46.2858 30.551 45.9246 31.4231 45.2816 32.066C44.6386 32.709 43.7665 33.0702 42.8572 33.0702Z"
        stroke="white"
        strokeWidth="1.75"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.2858 24.4988V15.4817C10.3126 13.7092 10.6888 11.9595 11.393 10.3327C12.0972 8.70585 13.1154 7.23399 14.3894 6.0014C15.6634 4.76881 17.1681 3.79972 18.8173 3.14965C20.4665 2.49959 22.2277 2.18133 24.0001 2.2131C25.7725 2.18133 27.5337 2.49959 29.1829 3.14965C30.832 3.79972 32.3367 4.76881 33.6107 6.0014C34.8847 7.23399 35.903 8.70585 36.6071 10.3327C37.3113 11.9595 37.6876 13.7092 37.7144 15.4817V24.4988M30.8572 42.4988C32.6758 42.4988 34.42 41.7764 35.7059 40.4904C36.9919 39.2044 37.7144 37.4603 37.7144 35.6417V27.9274M30.8572 42.4988C30.8572 43.6355 30.4057 44.7255 29.602 45.5293C28.7982 46.333 27.7081 46.7845 26.5715 46.7845H21.4286C20.292 46.7845 19.2019 46.333 18.3982 45.5293C17.5945 44.7255 17.1429 43.6355 17.1429 42.4988C17.1429 41.3622 17.5945 40.2721 18.3982 39.4684C19.2019 38.6646 20.292 38.2131 21.4286 38.2131H26.5715C27.7081 38.2131 28.7982 38.6646 29.602 39.4684C30.4057 40.2721 30.8572 41.3622 30.8572 42.4988ZM5.14293 19.356H8.5715C9.02616 19.356 9.46219 19.5366 9.78368 19.8581C10.1052 20.1796 10.2858 20.6156 10.2858 21.0702V31.356C10.2858 31.8106 10.1052 32.2467 9.78368 32.5681C9.46219 32.8896 9.02616 33.0702 8.5715 33.0702H5.14293C4.23361 33.0702 3.36154 32.709 2.71856 32.066C2.07558 31.4231 1.71436 30.551 1.71436 29.6417V22.7845C1.71436 21.8752 2.07558 21.0031 2.71856 20.3602C3.36154 19.7172 4.23361 19.356 5.14293 19.356ZM42.8572 33.0702H39.4286C38.974 33.0702 38.5379 32.8896 38.2165 32.5681C37.895 32.2467 37.7144 31.8106 37.7144 31.356V21.0702C37.7144 20.6156 37.895 20.1796 38.2165 19.8581C38.5379 19.5366 38.974 19.356 39.4286 19.356H42.8572C43.7665 19.356 44.6386 19.7172 45.2816 20.3602C45.9246 21.0031 46.2858 21.8752 46.2858 22.7845V29.6417C46.2858 30.551 45.9246 31.4231 45.2816 32.066C44.6386 32.709 43.7665 33.0702 42.8572 33.0702Z"
        stroke="black"
        strokeOpacity="0.3"
        strokeWidth="1.75"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19 30C19 30 20.785 30.9998 24 31C27.215 31.0002 29 30 29 30"
        stroke="white"
        strokeWidth="1.75"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19 30C19 30 20.785 30.9998 24 31C27.215 31.0002 29 30 29 30"
        stroke="black"
        strokeOpacity="0.3"
        strokeWidth="1.75"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16 21.25C16 21.25 17 20.25 18.5 20.25C20 20.25 21 21.25 21 21.25"
        stroke="white"
        strokeWidth="1.75"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16 21.25C16 21.25 17 20.25 18.5 20.25C20 20.25 21 21.25 21 21.25"
        stroke="black"
        strokeOpacity="0.3"
        strokeWidth="1.75"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M27 21.25C27 21.25 28 20.25 29.5 20.25C31 20.25 32 21.25 32 21.25"
        stroke="white"
        strokeWidth="1.75"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M27 21.25C27 21.25 28 20.25 29.5 20.25C31 20.25 32 21.25 32 21.25"
        stroke="black"
        strokeOpacity="0.3"
        strokeWidth="1.75"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
